import { render, staticRenderFns } from "./KnowledgeShow.vue?vue&type=template&id=12c8ff54&scoped=true&"
import script from "./KnowledgeShow.vue?vue&type=script&lang=ts&"
export * from "./KnowledgeShow.vue?vue&type=script&lang=ts&"
import style0 from "./KnowledgeShow.vue?vue&type=style&index=0&id=12c8ff54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c8ff54",
  null
  
)

export default component.exports